<template>
  <div>
    <v-btn
      fab
      bottom
      right
      color="pink"
      dark
      fixed
      @click.stop="dialog = !dialog"
    >
      <v-icon>add</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" width="800px">
      <v-card>
        <v-card-title
          class="grey lighten-4 py-4 title"
        >
          Add User
        </v-card-title>
        <v-container grid-list-sm class="pa-4">
          <v-layout align-center row wrap>
            <v-flex xs12 align-center justify-space-between>
              <v-text-field
                placeholder="Login"
                v-model="userLogin"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 align-center justify-space-between>
              <v-text-field
                placeholder="User name"
                v-model="modelName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 align-center justify-space-between>
              <v-text-field
                placeholder="User email"
                v-model="userEmail"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 align-center justify-space-between>
              <v-text-field
                type="password"
                placeholder="User password"
                v-model="userPassword"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 align-center justify-space-between>
              <v-text-field
                type="number"
                placeholder="Age"
                v-model="userAge"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 align-center justify-space-between>
              <v-select
                label="Sex"
                :items="sex"
                v-model="userSex"
              ></v-select>
            </v-flex>
            <v-flex xs12 align-center justify-space-between>
              <v-text-field
                label="Description (bio)"
                v-model="userDescription"
                textarea
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6 align-center justify-space-between>
              <v-img
                v-if="avatar"
                size="50"
                aspect-ratio="1"
                :src="avatar"
              ></v-img>
              <v-progress-linear
                v-if="uploadPercentage !== 0 && uploadPercentage !== 100"
                :value="uploadPercentage"
                color="light-blue"
              ></v-progress-linear>
            </v-flex>

            <v-flex xs12 sm6 md12>
              <v-btn
                color="primary"
                class="mt-3 ml-0"
                :disabled="disabled.uploadPhotoForEmbalmersBtn"
                :loading="disabled.uploadPhotoForEmbalmersBtn"
                :prepend-icon="uploadStatus"
                @click="$refs.inputUpload.click()"
                type="file">Upload Optional Photo
              </v-btn>
              <input
                v-show="false"
                accept=".jpg,.png"
                ref="inputUpload"
                type="file"
                @change="onChange"
              >
              <v-snackbar
                v-model="snackbar"
                bottom
                color="success"
                multi-line
                :timeout="2000"
              ></v-snackbar>
            </v-flex>

            <v-flex xs12 align-center justify-space-between>
              <v-checkbox v-model="userIsVendor" label="Is bookable"></v-checkbox>
            </v-flex>

          </v-layout>
        </v-container>
        <v-card-actions>
          <v-btn color="primary" @click="saveNew" :disabled="saveNewDisabled">Save</v-btn>
          <v-btn flat @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AppMainDialog :open="dialogOpen" :message="dialogMessage" @closedialog="dialogOpen = false"></AppMainDialog>
  </div>
</template>

<script>
  import userAPI from '@/api/user'
  import AppMainDialog from '@/components/AppMainDialog'
  import itemTypesMixins from '@/mixins/ItemTypes'
  import ItemCheckList from '@/components/ItemCheckList'
  import UserServices from '@/components/UserServices'
  import AddButtonMixins from '@/mixins/AddButton'

  export default {
    components: { AppMainDialog, ItemCheckList, UserServices },
    mixins: [ AddButtonMixins, itemTypesMixins ],
    data () {
      return {
        photoForUser: null,
        userPhotoIsUploaded: false,
        user_photo_url: false,
        uploadPercentage: 0,
        snackbar: false,
        disabled: {
          uploadPhotoForEmbalmersBtn: false
        },
        resources: 'users',
        dialog: false,
        modelName: '',
        userLogin: '',
        userEmail: '',
        userPassword: '',
        userAvatarEvent: null,
        sex: ['Male', 'Female'],
        userSex: null,
        userAge: null,
        userDescription: null,
        userIsVendor: false,
        userServiceDescription: null,
        editCheckListAfterSave: false,
        savedItemId: null,
        userServicePrice: null,
        saveNewDisabled: false,
        savedUserId: null,
        dialogMessage: '',
        dialogOpen: false
      }
    },
    watch: {
      dialogOpen () {
        if (this.savedItemId) {
          let form = new FormData()
          form.append('avatar', this.userAvatarEvent)

          this.$store.getters.axios.post(this.$store.getters.config.api_host + '/api/users/' + this.savedItemId + '/avatar', form, {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: function (progressEvent) {
              this.uploadPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total))
            }.bind(this)
          }).then(result => {
            this.disabled.uploadPhotoForEmbalmersBtn = false
            this.userPhotoIsUploaded = true

            this.snackbar = true
            setTimeout(() => {
              this.userPhotoIsUploaded = false
            }, 5000)
          })
        }
      },
      savedItemId (val) {
        this.savedUserId = val
      }
    },
    computed: {
      uploadStatus () {
        return this.userPhotoIsUploaded ? 'done' : ''
      },
      avatar () {
        return this.user_photo_url || this.$dfsConfig.default_avatar_url
      }
    },
    methods: {
      onChange (event) {
        this.user_photo_url = URL.createObjectURL(event.target.files[0])
        this.userAvatarEvent = event.target.files[0]
      },
      editCheckListAfterSaveMethod (result) {
        this.$bus.$emit('resource-added')

        userAPI.getLinkedServices(result.inserted_id).then(result => {
          this.savedItemId = result[0].id

          this.saveNewSuccess(result)
        }, () => {})
      },
      editServicesAfterSaveMethod (result) {
        this.$bus.$emit('resource-added')

        this.saveNewDisabled = true

        this.savedUserId = result.inserted_id
      },
      saveNew () {
        let payload = {
          name: this.modelName,
          username: this.userLogin,
          email: this.userEmail,
          is_vendor: this.userIsVendor,
          age: this.userAge,
          sex: this.userSex,
          description: this.userDescription,
          password: this.userPassword
        }

        if (this.userIsVendor) {
          payload.service_description = this.userServiceDescription
          payload.service_price = this.userServicePrice
        }

        // let callback = null

        let result = userAPI.add(payload)

        // if (this.userIsVendor) {
        //   callback = this.editServicesAfterSaveMethod
        // } else {
        //   callback = this.saveNewSuccess
        // }
        // // if (this.editCheckListAfterSave) {
        // //   callback = this.editCheckListAfterSaveMethod
        // // } else {
        // //   callback = this.saveNewSuccess
        // // }
        //
        // result.then(callback, this.saveNewError)
        result.then(this.saveNewSuccess, this.saveNewError)
        // userAPI.add(payload).then(result => {
        //   let payloadService = {
        //     name: this.modelName,
        //     description: this.userServiceDescription,
        //     amount: 1,
        //     users_id: result.inserted_id,
        //     is_available: result.inserted_id,
        //     is_vendor: false
        //   }

        //   if (this.userIsVendor) {
        //     servicesAPI.add(payloadService).then(this.saveNewSuccess, this.saveNewError)
        //   } else {
        //     this.saveNewSuccess()
        //   }
        // }, this.saveNewError)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AddUserButton.vue?27247bcc